/*
 * Copyright (c) 2022. Venus GmbH <info@venus.bayern> - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 * Written by Dominik Lippl <dl@venus.bayern>
 */

import axios from "axios";

let token = undefined;
const requests = [];

const axiosInstance = axios.create({
  withCredentials: true,
  baseURL: process.env.NODE_ENV === "development" ? "http://localhost:2000" : (process.env.VUE_APP_OAUTH ? `${process.env.VUE_APP_OAUTH}` : "")
});

/*
axiosInstance.interceptors.response.use(response => {
    return response;
}, error => {
    if (error.code === 'ERR_NETWORK') {
        const error = 'Aktuell ist die MediaCollection nicht erreichbar, bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.';
        store.dispatch('system/setError', error);
        store.dispatch('message/addMessage', {
            message: error,
            type: "error"
        });
    } else if (error.response && error.response.status === 500) {
        store.dispatch('message/addMessage', {message: error.response.data.message, type: "error"});
    }

    return Promise.reject(error);
});
 */

axiosInstance.interceptors.request.use(function(config) {
  if (token)
    config.headers.Authorization = token ? `Bearer ${token}` : "";

  return config;
});

export default {
  get(name, path) {
    this.cancel(name);

    const request = axios.CancelToken.source();
    requests.push({ name: name, request: request });
    return axiosInstance.get(path, { cancelToken: request.token });
  },
  put(name, path, data = {}) {
    this.cancel(name);

    const request = axios.CancelToken.source();
    requests.push({ name: name, request: request });
    return axiosInstance.put(path, data, { cancelToken: request.token });
  },
  post(name, path, data = {}) {
    this.cancel(name);

    const request = axios.CancelToken.source();
    requests.push({ name: name, request: request });
    return axiosInstance.post(path, data, { cancelToken: request.token });
  },
  patch(name, path, data = {}) {
    this.cancel(name);

    const request = axios.CancelToken.source();
    requests.push({ name: name, request: request });
    return axiosInstance.patch(path, data, { cancelToken: request.token });
  },
  delete(name, path, payload) {
    this.cancel(name);

    const request = axios.CancelToken.source();
    requests.push({ name: name, request: request });
    return axiosInstance.delete(path, { cancelToken: request.token, data: payload });
  },
  cancel(name) {
    for (let entry of requests.map((value, index) => ({ index, value }))) {
      if (entry.value.name === name) {
        entry.value.request.cancel();
        requests.splice(entry.index, 1);
      }
    }
  },
  setToken(access_token) {
    token = access_token;
  },
  axiosInstance
};